import React from "react";
import { Loader2 } from "lucide-react";

export const money = (v) => {
  if (v === null || v === undefined || v === "") return "—";
  return `AED ${Number(v).toLocaleString("en-AE", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
};

export const num = (v, d = 0) =>
  v === null || v === undefined ? "—" : Number(v).toLocaleString("en-AE", { maximumFractionDigits: 2 });

export function PageHeader({ title, subtitle, children }) {
  return (
    <div className="flex flex-col sm:flex-row sm:items-end sm:justify-between gap-4 mb-6">
      <div>
        <h1 className="text-2xl sm:text-3xl font-bold tracking-tight text-white font-display">{title}</h1>
        {subtitle && <p className="text-sm text-muted-foreground mt-1">{subtitle}</p>}
      </div>
      {children && <div className="flex flex-wrap items-center gap-2">{children}</div>}
    </div>
  );
}

export function Spinner({ label = "Loading" }) {
  return (
    <div className="flex items-center justify-center py-24 text-muted-foreground gap-2">
      <Loader2 className="h-5 w-5 animate-spin" /> {label}…
    </div>
  );
}

const STATUS_STYLES = {
  pending: "bg-amber-500/10 text-amber-400 border-amber-500/30",
  preparing: "bg-sky-500/10 text-sky-400 border-sky-500/30",
  ready: "bg-emerald-500/10 text-emerald-400 border-emerald-500/30",
  dispatched: "bg-purple-500/10 text-purple-400 border-purple-500/30",
  completed: "bg-emerald-600/15 text-emerald-300 border-emerald-500/30",
  cancelled: "bg-slate-500/10 text-slate-400 border-slate-500/30",
  "Submitted for Approval": "bg-amber-500/10 text-amber-400 border-amber-500/30",
  "Under Review": "bg-sky-500/10 text-sky-400 border-sky-500/30",
  "More Information Required": "bg-orange-500/10 text-orange-400 border-orange-500/30",
  Approved: "bg-emerald-500/10 text-emerald-400 border-emerald-500/30",
  Rejected: "bg-rose-500/10 text-rose-400 border-rose-500/30",
  "Scheduled for Activation": "bg-violet-500/10 text-violet-400 border-violet-500/30",
  Draft: "bg-slate-500/10 text-slate-300 border-slate-500/30",
  Active: "bg-emerald-500/10 text-emerald-400 border-emerald-500/30",
  Inactive: "bg-slate-500/10 text-slate-400 border-slate-500/30",
  OK: "bg-emerald-500/10 text-emerald-400 border-emerald-500/30",
  WATCH: "bg-amber-500/10 text-amber-400 border-amber-500/30",
  "NEAR CAPACITY": "bg-orange-500/10 text-orange-400 border-orange-500/30",
  "AT CAPACITY": "bg-orange-500/15 text-orange-300 border-orange-500/40",
  "OVER CAPACITY": "bg-rose-500/15 text-rose-300 border-rose-500/40",
};

export function StatusPill({ status, className = "", testid }) {
  const s = STATUS_STYLES[status] || "bg-slate-500/10 text-slate-300 border-slate-500/30";
  const long = String(status).length > 8;
  return (
    <span
      data-testid={testid}
      className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-semibold border ${long ? "" : "capitalize"} ${s} ${className}`}
    >
      {long ? status : String(status).toLowerCase()}
    </span>
  );
}

export function Empty({ icon: Icon, title, hint }) {
  return (
    <div className="text-center py-16 border border-dashed border-border rounded-xl">
      {Icon && <Icon className="h-10 w-10 mx-auto text-muted-foreground/50 mb-3" />}
      <p className="text-slate-300 font-medium">{title}</p>
      {hint && <p className="text-sm text-muted-foreground mt-1">{hint}</p>}
    </div>
  );
}

export const BRAND_DOT = {
  amber: "bg-yellow-400", emerald: "bg-green-500", rose: "bg-pink-500",
  sky: "bg-teal-400", violet: "bg-violet-500",
};
